export default "__VITE_ASSET__DCZJgmo5__"